import React, {Component} from "react";
import {Form, Input , Radio,Row,Col} from 'antd';
import NHFetch from "../../../utils/NHFetch";

const FormItem = Form.Item;

/**
 * 绿色通道查看表单
 * @author admin
 * @date 2018-03-16 11:28:34
 * Version: 1.0
 */
class ViewForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            blyy:'',
            fj:[],
        }
    }
    
    
    render() {
        const initFormData = this.props.initFormData;

        return (
            <div>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}> 姓名(学号)：</Col>
                    <Col span={8}>{initFormData.XH?`${initFormData.XM}(${initFormData.XH})`:''}</Col>
                    <Col span={4} style={{textAlign:'right'}}>性别：</Col>
                    <Col span={8}>{initFormData.XB}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>调整前学院：</Col>
                    <Col span={8}>{initFormData.BMMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>调整后学院：</Col>
                    <Col span={8}>{initFormData.YXH}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>调整前专业：</Col>
                    <Col span={8}>{initFormData.ZYMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>调整后专业：</Col>
                    <Col span={8}>{initFormData.ZYH}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>调整前班级：</Col>
                    <Col span={8}>{initFormData.BJMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>调整后班级：</Col>
                    <Col span={8}>{initFormData.BJH}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>申请理由：</Col>
                    <Col span={20}>{initFormData.SQLY}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>申请时间：</Col>
                    <Col span={8}>{initFormData.SQSJ}</Col>
                </Row>
                
              
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                        <Col span={4} style={{textAlign:'right'}}>审核状态：</Col>
                        <Col span={8}>{initFormData.SHZTMC}</Col>
                        <Col span={4} style={{textAlign:'right'}}>审核时间：</Col>
                        <Col span={8}>{initFormData.SHSJ}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                        <Col span={4} style={{textAlign:'right'}}>审核意见：</Col>
                        <Col span={20}>{initFormData.SHYJ}</Col>
                </Row>
                
            </div>
        );
    }
}

export default ViewForm;


// WEBPACK FOOTER //
// ./components/swbl/zytz/ViewForm.js